import { Grid, Typography } from "@mui/material";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { useTheme } from "@mui/material/styles";
import React from "react";

export interface FraudDetectWarningProps {
    warnings: string[]
}

const FraudDetectWarning: React.FC<FraudDetectWarningProps> = (props) => {
    const theme = useTheme();
    return (
        <Grid display={'flex'} justifyContent={'center'} flexDirection={'column'} py={1}>
            <Typography display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{color:theme?.color?.failure}}><b>Fraud Detect</b></Typography>
            {props.warnings.map((warning: any) => <Typography sx={{color:theme?.color?.failure}} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                {
                    warning && warning !== "" &&
                    <><PriorityHighIcon/> {warning}</>
                }
            </Typography>)}
        </Grid>
    )
};

export default FraudDetectWarning;